export const chemistryCalculators = [
  {
    name: "حساب الكتلة المولية",
    link: "/calculator/ar/molar-mass-calculator/",
    description:
      "حاسبة الكتلة المولية هي أداة تستخدم لحساب الكتلة المولية لمركب كيميائي عن طريق إدخال صيغته الكيميائية.",
    showMain: true,
  },
  {
    name: "حساب كتلة الحديد",
    link: "/calculator/ar/iron-mass/",
    description:
      "حاسبة كتلة الحديد تقوم بحساب كتلة قطعة الحديد بناءً على الأبعاد المدخلة.",
    showMain: true,
  },
  {
    name: "حساب كتلة الماء",
    link: "/calculator/ar/water-mass/",
    description:
      "حاسبة كتلة الماء تقوم بحساب كتلة الماء بناءً على الحجم وكثافة الماء.",
    showMain: true,
  },
  {
    name: "حاسبة حجم الغاز",
    link: "/calculator/ar/gasvolume/",
    description:
      "تقوم هذه الحاسبة بحساب حجم الغاز بسهولة وايضاح الخطوات اللازمة لحسابه",
    showMain: true,
  },
  {
    name: "حاسبة شحنة الأيون",
    link: "/calculator/ar/ion-charge-calculator/",
    description:
      "تقوم هذه الحاسبة بحساب شحنة الأيون للعناصر الكيميائية بسهولة وايضاح الخطوات اللازمة لحسابها",
    showMain: true,
  },
  {
    name: " حساب نقطة الندى  - حاسبة نقطة الندى",
    link: "/calculator/ar/dew-point-calculator/",
    description:
      "احسب درجة الحرارة التي يجب أن يبرد إليها الهواء ليصل إلى التشبع ويشكل الندى.",
    showMain: true,
  },
  {
    name: "حساب الذائبية  - حاسبة الذائبية",
    link: "/calculator/ar/solubility-calculator/",
    description:
      "استخدم حاسبة الذائبية لحساب أقصى كمية من المادة التي يمكن إذابتها في الماء. اعرف الفرق بين المحاليل المشبعة وغير المشبعة.",
  },
  {
    name: "حساب الوزن الجزيئي  - حاسبة الوزن الجزيئي لمركب",
    link: "/calculator/ar/molecular-weight-calculator/",
    description:
      "استخدم حاسبة الوزن الجزيئي لحساب الوزن الجزيئي لأي مركب كيميائي بسهولة. أدخل العناصر الكيميائية التي يتكون منها المركب لحساب الوزن الجزيئي بدقة.",
  },
  {
    name: "حاسبة وزن المعادن",
    link: "/calculator/ar/metal-weight/",
    description:
      "استخدم حاسبة وزن المعادن لحساب وزن المعادن المختلفة بسهولة ودقة. أدخل الأبعاد والكثافة للحصول على الوزن المطلوب.",
      showMain: true,
  },
  {
    name: "حاسبة عدد المولات",
    link: "/calculator/ar/moles-calculator/",
    description:
      "استخدم حاسبة عدد المولات لحساب عدد المولات لأي مادة كيميائية بسهولة. أدخل الكتلة، التركيز، عدد الجسيمات، أو حجم الغاز عند الظروف المعيارية (STP) للحصول على النتيجة بدقة.",
  },
  {
    name: "حاسبة المولارية",
    link: "/calculator/ar/molarity/",
    description:
      "استخدم حاسبة المولارية لحساب تركيز المحاليل الكيميائية بسهولة. أدخل عدد المولات وحجم المحلول للحصول على التركيز المولاري بدقة.",
  }, 
  {
    name: "حاسبة الكثافة",
    link: "/calculator/ar/density/",
    description:
      "استخدم حاسبة الكثافة لحساب كثافة المواد المختلفة بسهولة. أدخل الكتلة والحجم للحصول على الكثافة بدقة.",
  },
  // solution-dilution
  {
    name: "حاسبة تخفيف المحاليل",
    link: "/calculator/ar/solution-dilution/",
    description:
      "استخدم حاسبة تخفيف المحاليل لحساب تركيز المحلول بعد التخفيف بسهولة. أدخل التركيز الأصلي، حجم المحلول الأصلي، وحجم المحلول المخفف للحصول على التركيز الجديد بدقة.",
  },
  //ideal-gas-law
  {
    name: "حاسبة قانون الغاز المثالي",
    link: "/calculator/ar/ideal-gas-law/",
    description:
      "استخدم حاسبة قانون الغاز المثالي لحساب أي من المتغيرات في المعادلة PV = nRT بسهولة. أدخل الضغط، الحجم، عدد المولات، أو درجة الحرارة للحصول على النتيجة بدقة.",
  } ,
  // gibbs-free-energy

  {
    name: "حاسبة الطاقة الحرة لجبس",
    link: "/calculator/ar/gibbs-free-energy/",
    description:
      "استخدم حاسبة الطاقة الحرة لجبس لحساب التغير في الطاقة الحرة لجبس (ΔG) لأي تفاعل كيميائي بسهولة. أدخل التغير في الإنثالبي (ΔH) والتغير في الإنتروبيا (ΔS) ودرجة الحرارة للحصول على النتيجة بدقة.",
  },
  //titration
{
    name: "حاسبة المعايرة",
    link: "/calculator/ar/titration/",
    description:
      "استخدم حاسبة المعايرة لحساب تركيز المحلول المجهول بسهولة. أدخل حجم وتركيز المحلول المعروف، وحجم المحلول المجهول للحصول على التركيز الجديد بدقة.",
},
// ksp-calculator
{
    name: "حاسبة ثابت الذوبانية (Ksp)",
    link: "/calculator/ar/ksp-calculator/",
    description:
      "استخدم حاسبة ثابت الذوبانية (Ksp) لحساب ثابت الذوبانية لأي مركب أيوني بسهولة. أدخل تركيز الأيونات في المحلول للحصول على Ksp بدقة.",
},
// ph-acid
{
    name: "حاسبة pH للأحماض",
    link: "/calculator/ar/ph-acid/",
    description:
      "استخدم حاسبة pH للأحماض لحساب قيمة pH لأي محلول حمضي بسهولة. أدخل تركيز الأيونات الهيدروجينية (H+) أو تركيز الحمض للحصول على قيمة pH بدقة.",
}

];
export default chemistryCalculators;